import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles({
	noConditionText: {
		color: colors.gray[500]
	}
})

export default useStyles
